import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

export const getPricePerQuantityApi = (data, callback, errorCallBack) => {
    return async (dispatch) => {
        serviceCall({
            url: apiConstants.PAYMENT_GATEWAY.GET_PRICE_PER_QUANTITY,
            method: 'get',
            data: data,
        })
            .then((response) => {
                callback && callback(response)
            })
            .catch((error) => {
                errorCallBack && errorCallBack(error.response)
            })
    }
} 